module.exports = __webpack_public_path__ + "static/img/img-11.08615d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-11.jpg
// module id = 94
// module chunks = 0